import axios from "axios";

const publicAxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_SHOPWARE_URL}reply-api`,
  headers: {
    "sw-access-key": process.env.REACT_APP_SHOPWARE_API_SECRET,
    Accept: "application/json",
    "Content-Type": "application/json",
    "sw-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});

export default publicAxiosInstance;
